module.exports = __webpack_public_path__ + "static/media/iso-cert.1b400dbd.jpg";